<template>
    <!-- <div class="card mb-25 border-0 rounded-0 bg-white working-schedule-box"> -->
    <div class="working-schedule-box mt-25">
        <!-- <div class="card-body p-15 p-sm-20 p-sm-25 p-lg-30 letter-spacing"> -->
        <div class="letter-spacing">
            <VDatePicker v-model="date" class="therapy-calendar" view="weekly" :locale="$i18n.locale"
                v-on:dayclick="loadData" />
            <ul class="info-list ps-0 mb-0 list-unstyled mt-10">
                <li class="d-inline-block p-0 border-0">
                    <div class="d-flex align-items-center">
                        <span class="d-block w-10 h-10 bg-primary rounded-circle me-8"></span>
                        <span class="fw-bold">
                            <span class="text-muted fw-semibold text-uppercase small">{{
                                $t(`feature.therapy.intake.$status.${status.waiting}`) }}</span>
                        </span>
                    </div>
                </li>
                <li class="d-inline-block p-0 border-0">
                    <div class="d-flex align-items-center">
                        <span class="d-block w-10 h-10 bg-success rounded-circle me-8"></span>
                        <span class="fw-bold">
                            <span class="text-muted fw-semibold text-uppercase small">{{
                                $t(`feature.therapy.intake.$status.${status.taken_in_time}`) }}</span>
                        </span>
                    </div>
                </li>
                <li class="d-inline-block p-0 border-0">
                    <div class="d-flex align-items-center">
                        <span class="d-block w-10 h-10 bg-warning rounded-circle me-8"></span>
                        <span class="fw-bold">
                            <span class="text-muted fw-semibold text-uppercase small">{{
                                $t(`feature.therapy.intake.$status.${status.taken_not_in_time}`) }}</span>
                        </span>
                    </div>
                </li>
                <li class="d-inline-block p-0 border-0">
                    <div class="d-flex align-items-center">
                        <span class="d-block w-10 h-10 bg-danger rounded-circle me-8"></span>
                        <span class="fw-bold">
                            <span class="text-muted fw-semibold text-uppercase small">{{
                                $t(`feature.therapy.intake.$status.${status.not_taken}`) }}</span>
                        </span>
                    </div>
                </li>
            </ul>
            <div v-if="dayStats && intakes?.length !== 0">
                <div class="row mt-10">
                    <div class="col-4">
                        <div class="d-flex flex-column gap-3 h-100 justify-content-end">
                            <span class="fw-bold text-primary text-badge d-inline-block"> {{ dayStats.waiting_response
                                }}
                                <span class="text-muted fw-normal text-uppercase small">{{
                                    $t(`feature.therapy.intake.$status.${status.waiting}`) }}</span></span>
                            <span class="fw-bold text-success text-badge d-inline-block"> {{ dayStats.taken_in_time }}
                                <span class="text-muted fw-normal text-uppercase small">{{
                                    $t(`feature.therapy.intake.$status.${status.taken_in_time}`) }}</span></span>
                            <span class="fw-bold text-warning text-badge d-inline-block"> {{ dayStats.taken_not_in_time
                                }}
                                <span class="text-muted fw-normal text-uppercase small">{{
                                    $t(`feature.therapy.intake.$status.${status.taken_not_in_time}`) }}</span></span>
                            <span class="fw-bold text-danger text-badge d-inline-block"> {{ dayStats.not_taken }}
                                <span class="text-muted fw-normal text-uppercase small">{{
                                    $t(`feature.therapy.intake.$status.${status.not_taken}`) }}</span></span>
                        </div>
                    </div>
                    <div class="col-8">
                        <DayIntakeStatsChart :stats="dayStats" />
                    </div>
                </div>
            </div>
            <div class="schedule-list mt-15 mt-md-20">
                <SpinnerLoading v-if="intakes === undefined" class="mt-50" />
                <template v-else-if="intakes?.length === 0">
                    <p class="text-muted">{{ $t('feature.therapy.no_therapy_scheduled_today') }}</p>
                </template>
                <template v-else>
                    <div v-for="intake of intakes" :key="intake.id"
                        class="list-item pt-15 pb-15 pt-md-20 pb-md-20 ps-20 pe-15 position-relative d-sm-flex justify-content-between align-items-center"
                        :class="intake.status === status.waiting ? 'bg-f2f1f9' : intake.status === status.taken_in_time ? 'bg-ecf3f2' : intake.status === status.taken_not_in_time ? 'bg-f9faf7' : 'bg-faf7f7'">
                        <div class="content">
                            <div class="d-flex align-items-center mb-5">
                                <h6 class="fw-bold mb-1">
                                    {{ intakeTime(intake.time) }}
                                </h6>
                            </div>
                            <span class="d-block text-black fw-semibold">
                                {{ intake?.drug ?? '' }}
                                <span v-if="env === 'kareena'" class="ms-2 small">{{ getTherapy(intake.therapy_id)?.dose ?? '' }}</span>
                            </span>
                        </div>
                    </div>
                </template>

            </div>
        </div>
    </div>
</template>
<script lang="ts">
import API from '@/services/api/api.service';
import { Intake, IntakeStatus, Therapy, TherapyStats } from '@/utils/models/therapy.model';
import { PatientInfo } from '@/utils/models/user.model';
import { PropType } from 'vue';
import { defineComponent } from 'vue';
import SpinnerLoading from "@/components/Widgets/Spinner.vue";
import DayIntakeStatsChart from "@/components/FK/PatientDetail/DayIntakeStatsChart.vue";
import { CLIENT, Environment } from '@/utils/const/env';

export default defineComponent({
    name: "TherapyIntakeCalendar",
    props: {
        therapies: {
            type: Object as PropType<Therapy[]>,
            required: true
        },
        patient: {
            type: Object as PropType<PatientInfo>,
            required: true
        }
    },
    data: function () {
        return {
            intakes: undefined,
            dayStats: undefined,
            fetched_therapies: undefined,
            date: new Date(Date.now()),
        } as {
            intakes?: Intake[],
            fetched_therapies?: Therapy[],
            dayStats?: TherapyStats,
            date: Date,
        };
    },
    computed: {
        status() { return IntakeStatus },
        env(): Environment { return CLIENT },
    },
    watch: {
        therapies: function (_old, _new) {
            this.loadData();
        }
    },
    mounted() {
        this.loadData();
    },
    methods: {
        loadData() {
            this.fetched_therapies = undefined;
            this.intakes = undefined;
            this.dayStats = undefined;
            // this.getTherapies();
            this.getIntakes();
        },
        getTherapies() {
            API.getTherapies(this.patient.id!, { date: this.date }).then((response) => {
                if (response.data.success === true) {
                    this.fetched_therapies = response.data.data;
                }
                this.getIntakes();
            });
        },
        getIntakes() {
            this.intakes = undefined;
            this.dayStats = undefined;
            API.getIntakes({ patient_id: this.patient.id!, date: this.date! }).then((intakeResponse) => {
                if (intakeResponse.data.success) {
                    this.intakes = intakeResponse.data.data;
                    if (this.intakes?.length !== 0) {
                        this.getDayStats();
                    }
                }
            });
        },
        intakeTime(time: string) {
            var parts = time.split(':');
            parts.splice(-1);
            return parts.join(':');
        },
        getDayStats() {
            API.getIntakeStats({ patient_id: this.patient.id!, date: this.date! }).then((response) => {
                this.dayStats = response.data.data;
            })
        },
        getTherapy(id: string): Therapy | undefined {
            return this.therapies?.find((therapy) => therapy.id === id);
        }
    },
    components: {
        SpinnerLoading,
        DayIntakeStatsChart,
    }
})
</script>